import * as Sentry from "@sentry/vue";
import store from "@/store";
import { CustomException } from "./customException";

export const initSentry = (vue, router) => {
  Sentry.init({
    Vue: vue,
    dsn: "https://55ee911bc1534c32a7b51681b0e8f368@o1064902.ingest.sentry.io/6346995",
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
    ],
    release: `dver-client@${process.env.VUE_APP_ENV}:${process.env.VUE_APP_GIT_REV}`,
    environment: process.env.VUE_APP_ENV,
    tracesSampleRate: process.env.VUE_APP_ENV === "dev" ? 1 : 0.2, // 트랜잭션 샘플링 비율, 에러 수집과 무관
    sampleRate: 1, // 에러 샘플링 비율
    attachProps: true, // props 정보 확인
    logErrors: true, // 콘솔에 에러 로그 출력
    trackComponents: true // vue 라이프사이클 같이 표시
  });

  Sentry.configureScope((scope) => {
    scope.setTag(
      "userUnique",
      store.getters["auth/tokenPayload"]()?.id ?? "비회원"
    );
    scope.setTag(
      "userName",
      store.getters["auth/tokenPayload"]()?.name ?? "비회원"
    );
    scope.setTag(
      "userId",
      store.getters["auth/tokenPayload"]()?.userId ?? "비회원"
    );
  });
};

/** 센트리 예외 처리 핸들러 */
export class ExceptionSentryHandler {
  constructor(response) {
    this.data = response.data;
    this.config = response.config ?? {};
    this.httpCode = response.status;
  }

  /** API 응답에러 처리 */
  apiException() {
    const responseCode = this.data?.code || 0;

    if (this.httpCode !== 200 || [400, 500].includes(responseCode)) {
      const notifedCode = this.httpCode === 200 ? responseCode : this.httpCode;

      Sentry.captureException(
        new CustomException(
          `[${notifedCode}] API 응답 에러`,
          this.config?.url ?? ""
        ),
        (scope) => {
          scope.setLevel("error");
          scope.setTags({
            issue: "API",
            apiErrorCode: notifedCode
          });
          scope.setContext("API 응답", {
            code: this.data.code,
            success: this.data.success,
            error: JSON.stringify(this.data.err),
            fullData: JSON.stringify(this.data)
          });
          scope.setContext("API 요청", {
            baseURL: this.config.baseURL,
            url: this.config.url,
            headers: this.config.headers,
            method: this.config.method,
            data: this.config.data,
            fullData: JSON.stringify(this.config)
          });
        }
      );
    }
  }
}
